import React from 'react'

export default function SpinnerLoader() {
  return (
    <div className="initial">
      <span className="loader"></span>
    </div>
  )
}
